import { authRoles } from "../../../auth/authRoles";
import EditInquiry from "./EditInquiry";
import Inquiry from "./Inquiry";
import TambahInquiry from "./TambahInquiry";

const inquiryRoute = [
  {
    path: "/jenis_pertanyaan/edit/:id",
    exact: true,
    component: EditInquiry,
    auth: authRoles.all,
  },
  {
    path: "/jenis_pertanyaan/tambah",
    exact: true,
    component: TambahInquiry,
    auth: authRoles.all,
  },
  {
    path: "/jenis_pertanyaan",
    exact: true,
    component: Inquiry,
    auth: authRoles.all,
  },
];

export default inquiryRoute;
